<template>
  <p>ERROR: This product option is not properly configured. Please contact us for assistance.</p>
</template>

<script>
  export default {
    name: 'builder-option-error',
  }
</script>



// WEBPACK FOOTER //
// Error.vue?1da10d82